
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatInputModule} from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { GenericTableComponent } from './generic-table.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { MatCheckboxModule } from '@angular/material/checkbox';

@NgModule({
    declarations: [GenericTableComponent],
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        MatInputModule,
        MatTableModule,
        MatFormFieldModule,
        MatSortModule,
        MatProgressSpinnerModule,
        MatPaginatorModule,
        ReactiveFormsModule,
        SharedModule,
        MatCheckboxModule,
        TranslateModule.forChild(),
    ],
    exports: [
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        GenericTableComponent
    ],
    providers: []
})
export class GenericTableComponentModule {}